module.exports = __webpack_public_path__ + "static/media/GN.6a1fe571.png";